import React, { createContext, useContext, useEffect, useState, useMemo } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../config/firebase";

const FirestoreDataContext = createContext(null);

export const FirestoreDataProvider = ({ children }) => {
  const [providers, setProviders] = useState([]);
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchAll() {
      try {
        const provSnap = await getDocs(collection(db, "service_providers"));
        const listSnap = await getDocs(collection(db, "listings"));
        setProviders(provSnap.docs.map(d => ({ id: d.id, ...d.data() })));
        setListings(listSnap.docs.map(d => ({ id: d.id, ...d.data() })));
      } catch (e) {
        console.error("Error fetching Firestore data", e);
      } finally {
        setLoading(false);
      }
    }
    fetchAll();
  }, []);

  const providersById = useMemo(() => {
    const map = {};
    providers.forEach(p => (map[p.id] = p));
    return map;
  }, [providers]);

  const listingsByProvider = useMemo(() => {
    const map = {};
    listings.forEach(l => {
      if (!map[l.providerId]) map[l.providerId] = [];
      map[l.providerId].push(l);
    });
    return map;
  }, [listings]);

  return (
    <FirestoreDataContext.Provider
      value={{ providers, listings, providersById, listingsByProvider, loading }}
    >
      {children}
    </FirestoreDataContext.Provider>
  );
};

export const useFirestoreData = () => useContext(FirestoreDataContext);
